import '../SingleInvestment/index.scss';
import Header from '../../../../../../../components/Header/Header';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { copyToClipboard, formatToNaira } from '../../../../../../../helpers/utils';
import {
  getIpoSubscriptionBrokerName,
  getIpoSubscriptionOfferName,
  getIpoSubscriptionStatusTag,
  toMilliseconds,
} from '../../../../../../../helpers/utils/investify';
import { IoCopyOutline } from 'react-icons/io5';
import useInvestify from '../../../../../../../hooks/useInvestify';
import { Loader } from '@piggytechng/component-library';
import NoData from '../../../../../../../components/NoData/NoData';
import dayjs from 'dayjs';

const SingleIpoInvestment = () => {
  const params = useParams();
  const offerId = params.offerId as string;

  const { IpoSubscriptions, isLoadingIpoSubscriptions } = useInvestify({ offerId });

  const summary = useMemo(() => {
    if (!IpoSubscriptions.length) return null;

    const totalAmount = IpoSubscriptions.reduce((sum, sub) => sum + Number(sub.total_amount), 0);
    const totalShares = IpoSubscriptions.reduce((sum, sub) => sum + Number(sub.total_shares), 0);

    return {
      title: IpoSubscriptions.map(getIpoSubscriptionOfferName).find(Boolean) || 'IPO Investment',
      totalAmount,
      totalShares,
      subscriptionCount: IpoSubscriptions.length,
    };
  }, [IpoSubscriptions]);

  return (
    <div className="single-investment-page single-ipo-investment-page">
      <Header name="Investify" backButton />

      <div className="content">
        {isLoadingIpoSubscriptions ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            <div className="investment-header">
              <div className="left-section">
                <h1>{summary?.title || 'IPO Investment'}</h1>
                <div className="id-container">
                  <span className="flex--2 cont">
                    <p>Offer ID: {offerId} </p>
                    <IoCopyOutline size={18} className="pointer" onClick={() => copyToClipboard('Offer ID', offerId)} />
                  </span>
                </div>
              </div>
            </div>

            {summary && (
              <div className="investment-data">
                <div className="data-box">
                  <p>Total Amount</p>
                  <h3>{formatToNaira(summary.totalAmount)}</h3>
                </div>
                <div className="data-box">
                  <p>Total Shares</p>
                  <h3>{summary.totalShares.toLocaleString()}</h3>
                </div>
                <div className="data-box">
                  <p>Subscriptions</p>
                  <h3>{summary.subscriptionCount}</h3>
                </div>
              </div>
            )}

            <h1 className="investment-offers-heading">Subscriptions</h1>

            {IpoSubscriptions.length > 0 ? (
              <div className="table-container single-investment single-ipo-investment">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="reference">Reference</th>
                      <th className="broker">Broker</th>
                      <th className="amount">Amount (₦)</th>
                      <th className="units">Shares</th>
                      <th className="units">Share Price</th>
                      <th className="expTime">Status</th>
                      <th className="expTime">Date</th>
                    </tr>
                  </thead>
                  <tbody className="table-body">
                    {IpoSubscriptions.map((subscription) => {
                      const brokerName = getIpoSubscriptionBrokerName(subscription);
                      const { label: statusLabel, tagClass } = getIpoSubscriptionStatusTag(subscription);

                      return (
                        <tr key={subscription.id} className="table-row">
                          <td className="reference">{subscription.transaction_reference}</td>
                          <td className="broker" title={brokerName}>
                            {brokerName}
                          </td>
                          <td className="amount">{formatToNaira(Number(subscription.total_amount))}</td>
                          <td className="units">{Number(subscription.total_shares).toLocaleString()}</td>
                          <td className="units">{formatToNaira(Number(subscription.unit_share_price))}</td>
                          <td className="expTime">
                            <p className={`mode ${tagClass}`}>{statusLabel}</p>
                          </td>
                          <td className="expTime">
                            {dayjs(toMilliseconds(subscription.created_at)).format('D MMM YYYY | h:mm A')}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No subscriptions at the moment.'} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SingleIpoInvestment;
